import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}
const SortVerticalIcon: FC<Props> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="sort icon">
      {/* <title>sort icon</title> */}
      <path
        d="M16 18L16 6M16 6L20 10.125M16 6L12 10.125"
        stroke={props.stroke || "currentColor" || "#52565C"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 6L8 18M8 18L12 13.875M8 18L4 13.875"
        stroke={props.stroke || "currentColor" || "#52565C"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SortVerticalIcon;
